import { render, staticRenderFns } from "./GoogleGeoTargeting.vue?vue&type=template&id=9d98afd8&scoped=true&"
import script from "./GoogleGeoTargeting.vue?vue&type=script&lang=js&"
export * from "./GoogleGeoTargeting.vue?vue&type=script&lang=js&"
import style0 from "./GoogleGeoTargeting.vue?vue&type=style&index=0&id=9d98afd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d98afd8",
  null
  
)

export default component.exports